// extracted by mini-css-extract-plugin
export var buttonContainer = "_8y-1";
export var fontSizeSelect = "_8y-3";
export var formatSelect = "_8y-2";
export var formats = "_8y-4";
export var hidden = "_8y-5";
export var icon = "_8y-6";
export var select = "_8y-0";